import { requestApi } from '@app/api';
import { withDocument } from '@app/api/paths';

export function shareDocument(payload: {
  workspaceId: string;
  documentId: string;
  targetUserId: string;
  participantId: string;
}) {
  return requestApi({
    method: 'POST',
    url: withDocument(`/workspaces/${payload.workspaceId}/documents/${payload.documentId}/share`),
    data: { targetUserId: payload.targetUserId, participantId: payload.participantId },
    credentials: true,
  });
}
